import { fetchDataTrace } from "../services/trace";

const handleFetchWallVisits = async ({ site }: any) => {
  const uri = `visits/sites/${site}/stations/visit`;
  const response = fetchDataTrace({ uri });
  return response;
};

export { handleFetchWallVisits };
